import MedianPriceCard from './median-price-card';
export default MedianPriceCard;